import { render, staticRenderFns } from "./CredentialList.vue?vue&type=template&id=64ce2420&"
import script from "./CredentialList.vue?vue&type=script&lang=js&"
export * from "./CredentialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports